export default __webpack_public_path__ + "static/franchise-4-3ec81df2492e3ba373b1598646a504f1.png";